<template>
  <div class="experts-page">
    <Expert :user="user" v-for="user in experts" :key="user.id" />
  </div>
</template>

<script>
import Expert from '@/components/experts/Expert'
import getUsers from '@/mixins/getUsers'

export default {
  name: 'Experts',
  components: { Expert },
  mixins: [getUsers],
  computed: {
    experts() {
      if (this.users.expert || this.users.moderator) {
        const users = [...this.users.expert ?? [], ...this.users.moderator ?? []]
        return users.filter(({ visible }) => visible)
          .sort((a,b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
      }

      return []
    },
  },
}
</script>

<style lang="scss">
#content.experts-page {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 15px;

  @include PC {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
  }

  @include mobile {
    padding: 10px 20px;
  }
}
</style>
